<div class="vcard-template style2" id="rootElement">
  <div class="page-home page">
    <div
      class="vcard-header gradient-red-orange-bg"
      style="background: rgb(31, 54, 92)"
    >
      <div class="vcard-header-wrapper">
        <div class="vcard-top-info">
          <img [src]="'data:image/png;base64,' + card?.logo" class="center" />
          <h2 class="name dynamicTextColor ng-binding">
            {{ card?.name }} {{ card?.surname }}
          </h2>
          <h6 class="title dynamicTextColor ng-binding">{{ card?.title }}</h6>
        </div>
        <div class="vcard-functions">
          <div class="vcard-functions-wrapper">
            <a href="{{ 'tel:' + card?.tel }}">
              <i class="icon-phone dynamicTextColor"></i>
              <small class="dynamicTextColor">Llamar</small>
            </a>
            <a
              class="last-element"
              href="{{
                'mailto:' + card?.email + '?subject=From%20my%20vCard&amp;body='
              }}"
              target="_newEmail"
            >
              <i class="icon-send dynamicTextColor"></i>
              <small class="dynamicTextColor">Email</small>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="vcard-body-wrapper">
      <div class="vcard-body">
        <div id="dvcard-details">
          <div class="vcard-row">
            <i><mat-icon>smartphone</mat-icon></i>
            <h4>
              <a class="ng-binding" href="{{ 'tel:' + card?.mvl }}">{{
                card?.mvl
              }}</a>
            </h4>
            <small>Móvil</small>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row pt0">
            <i class="icon icon-phone"></i>
            <h4>
              <a class="ng-binding" href="{{ 'tel:' + card?.tel }}"
                >{{ card?.tel }} - {{ card?.ext }}</a
              >
            </h4>
            <small>Teléfono</small>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row">
            <i class="icon icon-mail"></i>
            <h4>
              <a
                class="ng-binding"
                href="{{ 'mailto:' + card?.email }}"
                target="_newLink"
                >{{ card?.email }}</a
              >
            </h4>
            <small>Email</small>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row">
            <i class="icon icon-work"></i>
            <h4 class="ng-binding">{{ card?.orgname }}</h4>
            <small class="ng-binding">{{ card?.title }}</small>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row">
            <label></label>
            <i class="icon icon-event-location"></i>
            <h4 class="ng-binding">{{ card?.dir1 }}</h4>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row">
            <label></label>
            <i class="icon icon-event-location"></i>
            <h4 class="ng-binding">{{ card?.dir2 }}</h4>
          </div>
          <div class="vcard-separator"></div>
          <div class="vcard-row" ng-show="view.website">
            <i class="icon icon-earth"></i>
            <h4>
              <a
                class="ng-binding"
                href="{{ 'http://' + card?.web }}"
                target="_newLink"
                >{{ card?.web }}</a
              >
            </h4>
            <small>Sitio Web</small>
          </div>
          <div class="vcard-separator"></div>
          <div
            class="vcard-row follow-scroll contactData-container"
            ng-style="setPosition('contactData')"
          >
            <div class="fabs" id="saveContact">
              <a
                href="{{ card?.vcard }}"
                target="_self"
                rel="external"
                class="fab"
                id="prime"
                ng-style="{ background: view.color2 || '#607d8b' }"
                style="background: rgb(31, 54, 92)"
              >
                <span
                  class="hidden-xs"
                  ng-style="{
                    color: isColorLight(view.color2) ? 'black' : 'white'
                  }"
                  style="color: white"
                >
                  <i
                    class="prime iconFab icon-fab-share-add"
                    ng-style="{
                      color: isColorLight(view.color2) ? 'black' : 'white'
                    }"
                    style="color: white"
                  >
                  </i>
                  Descargar vCard
                </span>
                <i
                  class="prime iconFab icon-fab-share-add visible-xs"
                  ng-style="{
                    color: isColorLight(view.color2) ? 'black' : 'white'
                  }"
                  style="color: white"
                >
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- -->
</div>
